<div class="app-home-wrapper background-image">
  <div class="grid-container">
    <div class="frosted-pane">
      <div class="grid-container_top">
        <img class="grid-container_img" src="assets/logos/PyxisLogo.png" alt="PYXIS Logo">
        <h4 class="grid-container_title">Integrity Management</h4>
      </div>
      <section class="app-error-content-container-grid">
        <h1>No assets available!</h1>
        <p>You do not have permission to access any assets for this client. <br>Please contact <a href="http://www.technical-limits.com#contact" class="home-link">Marine Technical Limits</a> for assistance.</p>
      </section>
      <section class="app-error-content-container-grid">
        <a href="#" (click)="logOut()" class="button-info-central error-btn">Log Out</a>
        <div class="border-bottom"></div>
      </section>
      <section class="app-not-found-content-container-grid_bottom">
        <pyxis-footer-social class="social-grid"></pyxis-footer-social>
      </section>
    </div>
  </div>
</div>

